<template>
  <div class="content-right">
    <div class="school-list">
      <div class="module-title">
        <div class="title-box">
          直属院系列表
        </div>
      </div>
      <!-- <div class="title">直属院系列表</div> -->
      <div class="rate-list-title">
        <div class="title-one">序号</div>
        <div class="title-two">学院名称</div>
      </div>
      <div class="rate-content" v-if="type == 'risk'">
        <div
          ref="rateItemOne"
          v-for="(item, index) in schoolList"
          :key="index"
          @click="clickRow(item, index)"
          :class="index == 0 ? 'rate-list-pitch-on' : 'rate-list'"
        >
          <div class="serial-number">{{ index + 1 }}</div>
          <div class="rate-name">{{ item.schoolName }}</div>
        </div>
      </div>
      <div class="rate-content" v-else>
        <div
          ref="rateItemTwo"
          v-for="(item, index) in schoolList"
          :key="index"
          @click="clickRow(item, index)"
          class="rate-list"
        >
          <div class="serial-number">{{ index + 1 }}</div>
          <div class="rate-name">{{ item.schoolName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "schoolList",
  props: {
    schoolList: {
      type: Array,
      default: {
        return: []
      }
    },
    type: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    clickRow(row, index) {
      if (this.type == "risk") {
        this.$refs.rateItemOne.map((item) => {
          return (item.className = "rate-list");
        });
        this.$refs.rateItemOne[index].className = "rate-list-pitch-on";
      } else {
        this.$refs.rateItemTwo.map((item) => {
          return (item.className = "rate-list");
        });
        this.$refs.rateItemTwo[index].className = "rate-list-pitch-on";
      }
      this.$emit("clickRow", row);
    }
  }
};
</script>
<style scoped lang="scss">
.content-right {
  width: 100%;
  height: 500px;
  .school-list {
    padding: 0px 20px 0px 20px;
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/bigDataCollge/chart-view-bg-two.png") center
      center no-repeat;
    background-size: 100% 100%;
    .module-title {
      height: 40px;
      width: 220px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .title-box {
        line-height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgb(203, 224, 255);
      }
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
    .rate-list-title {
      height: 30px;
      width: 400px;
      display: flex;
      flex-direction: row;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f1f3ff;
      .title-one {
        width: 100px;
        line-height: 30px;
        text-align: center;
      }
      .title-two {
        width: 300px;
        line-height: 30px;
        text-align: center;
      }
    }
    .rate-content {
      width: 100%;
      height: 420px;
      overflow: scroll;
    }
    .rate-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 38px;
      text-align: center;
      background: rgba(17, 165, 215, 0.2);
      border-radius: 4px;
      margin-bottom: 8px;
      cursor: pointer;
      &:nth-child(2n) {
        background: rgba(17, 165, 215, 0.05);
      }
      .serial-number {
        width: 100px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 22px;
        text-align: center;
      }
      .rate-name {
        width: 300px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 22px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-child(1) {
        .rate-score {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          background: linear-gradient(180deg, #edefff 0%, #fff04d 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &:nth-child(2) {
        .rate-score {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          background: linear-gradient(180deg, #edefff 0%, #4d76ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &:nth-child(3) {
        .rate-score {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4cdff;
          line-height: 22px;
          background: linear-gradient(180deg, #ffffff 0%, #8e6236 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
    .rate-list-pitch-on {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 38px;
      text-align: center;
      background-image: linear-gradient(
        to left,
        rgba(39, 209, 237, 0),
        rgba(28, 188, 227, 1),
        rgba(17, 165, 215, 0)
      );
      border-radius: 4px;
      margin-bottom: 8px;
      .rate-name {
        width: 300px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffff00;
        line-height: 22px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .serial-number {
        width: 100px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffff00;
        line-height: 22px;
        text-align: center;
      }
    }
  }
}
</style>
